import {Controller} from "stimulus";

export default class extends Controller {
    connect() {
        console.log("autofocusing...")
        setTimeout(() => this.scope.element.focus(), 200);//needed to delay or it sometimes fires before dom fully fleshed
    }
}